import { useCallback } from "react";
import useUserDateTime from "hooks/useUserDateTime";
import validateTimeRange from "views/components/TimeRangeValidation";
import { normalizeIfClassifiedRelativeTimeRange } from "./RelativeTimeRangeClassifiedHelper";
const dateTimeValidate = async (activeTabTimeRange, limitDuration, formatTime, userTimezone) => {
  if (!activeTabTimeRange) {
    return {};
  }
  const normalizedTimeRange = normalizeIfClassifiedRelativeTimeRange(activeTabTimeRange);
  const timeRangeErrors = await validateTimeRange(normalizedTimeRange, limitDuration, formatTime, userTimezone);
  return Object.keys(timeRangeErrors).length !== 0 ? { timeRangeTabs: { [activeTabTimeRange.type]: timeRangeErrors } } : {};
};
const useTimeRangeValidation = (limitDuration = 0) => {
  const { formatTime, userTimezone } = useUserDateTime();
  return useCallback(
    ({ timeRangeTabs, activeTab }) => dateTimeValidate(activeTab ? timeRangeTabs[activeTab] : void 0, limitDuration, formatTime, userTimezone),
    [formatTime, limitDuration, userTimezone]
  );
};
export default useTimeRangeValidation;
